import { render, staticRenderFns } from "./ButtonListCdp.vue?vue&type=template&id=0058866d&"
import script from "./ButtonListCdp.vue?vue&type=script&lang=ts&"
export * from "./ButtonListCdp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports